import { render, staticRenderFns } from "./WrapperTooltip.vue?vue&type=template&id=53387d2a&scoped=true"
import script from "./WrapperTooltip.vue?vue&type=script&lang=js"
export * from "./WrapperTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53387d2a",
  null
  
)

export default component.exports